import React, { useState, useRef, useEffect } from "react";

import { Link } from "@reach/router";

import { Button, message, Avatar, Rate, Spin, Statistic, Space } from "antd";

import {
  ShopFilled,
  PlusCircleFilled,
  AppstoreFilled,
  FileExcelFilled,
  MessageFilled,
  CopyFilled,
  FileAddFilled,
  FundFilled,
  PieChartFilled,
  SafetyCertificateFilled,
  AppstoreOutlined,
  CopyOutlined,
  ThunderboltFilled,
  RobotFilled,
  CustomerServiceFilled,
  InsuranceFilled,
} from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";

import item1 from "../../images/item_01.jpg";
import item2 from "../../images/item_02.jpg";
import item3 from "../../images/item_03.jpg";
import item4 from "../../images/item_04.jpg";
import item5 from "../../images/item_05.jpg";
import item6 from "../../images/item_06.jpg";

import styles from "./Overview.module.less";

function Overview({ navigate, user, brand }) {
  const [loading, setLoading] = useState(true);
  const [newsCount, setNewsCount] = useState({ wait: 0, ok: 0, fail: 0 });
  const [productCount, setProductCount] = useState({ wait: 0, ok: 0, fail: 0 });
  // const [stars, setStars] = useState({
  //   order: "ASC",
  //   loading: true,
  //   max: 0,
  //   min: 0,
  //   current: 0,
  // });
  // const [diagnosis, setDiagnosis] = useState([]);
  const [edition, setEdition] = useState({});
  const [guide, setGuide] = useState({});

  // const chartLine = useRef();
  // const chartPizz = useRef();

  const onNewsCount = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`news/count`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setNewsCount(parsed.result);
    }
  };

  const onProductCount = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`product/count`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setProductCount(parsed.result);
    }
  };

  // const onChartLineLoad = async (params) => {
  //   let para = queryString.stringify(params);
  //   let parsed = await Http.get(`hour`, {
  //     searchParams: para,
  //   }).json();
  //   if (parsed.state === "ok") {
  //     let eChartFlow = echarts.init(chartLine.current);
  //     eChartFlow.setOption({
  //       grid: {
  //         top: "20px",
  //         right: "20px",
  //         bottom: "20px",
  //         left: "20px",
  //         containLabel: true,
  //       },
  //       xAxis: {
  //         type: "category",
  //         boundaryGap: false,
  //         data: parsed.result.data,
  //       },
  //       yAxis: {
  //         type: "value",
  //       },
  //       series: [
  //         {
  //           data: parsed.result.value,
  //           type: "line",
  //           areaStyle: {},
  //         },
  //       ],
  //     });
  //   }
  // };

  // const onChartPizzLoad = async (params) => {
  //   let para = queryString.stringify(params);
  //   let parsed = await Http.get(`hour`, {
  //     searchParams: para,
  //   }).json();
  //   if (parsed.state === "ok") {
  //     let eChartKeywords = echarts.init(chartPizz.current);
  //     eChartKeywords.setOption({
  //       tooltip: {
  //         trigger: "item",
  //         formatter: "{a} <br/>{b} : {c} ({d}%)",
  //       },
  //       legend: {
  //         orient: "vertical",
  //         left: "left",
  //         data: ["百度", "百度移动", "360", "搜狗", "头条", "神马"],
  //       },
  //       series: [
  //         {
  //           name: "关键词比例",
  //           type: "pie",
  //           radius: "80%",
  //           center: ["50%", "50%"],
  //           data: [
  //             { value: 335, name: "百度" },
  //             { value: 310, name: "百度移动" },
  //             { value: 234, name: "360" },
  //             { value: 135, name: "搜狗" },
  //             { value: 1548, name: "头条" },
  //             { value: 848, name: "神马" },
  //           ],
  //           emphasis: {
  //             itemStyle: {
  //               shadowBlur: 10,
  //               shadowOffsetX: 0,
  //               shadowColor: "rgba(0, 0, 0, 0.5)",
  //             },
  //           },
  //         },
  //       ],
  //     });
  //   }
  // };

  // const onDiagnosis = async (params) => {
  //   await new Promise((resolve, reject) => {
  //     setStars({ ...stars, order: "DESC", loading: true });
  //     setTimeout(() => {
  //       resolve();
  //     }, stars.max * 300);
  //   });
  //   let para = queryString.stringify(params);
  //   let parsed = await Http.get(`diagnosis`, {
  //     searchParams: para,
  //   }).json();
  //   if (parsed.state === "ok") {
  //     setDiagnosis(parsed.result.list);
  //     await new Promise((resolve, reject) => {
  //       setStars({
  //         ...stars,
  //         order: "ASC",
  //         loading: false,
  //         max: parsed.result.rate,
  //         current: 0,
  //       });
  //       setTimeout(() => {
  //         resolve();
  //       }, stars.max * 200);
  //     });
  //   }
  // };

  const onGuide = async (params) => {
    let para = queryString.stringify(params);
    let parsed = await Http.get(`guide`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      console.log(parsed.result);
      setGuide(parsed.result);
    }
  };

  const onEdition = async () => {
    let para = queryString.stringify({});
    let parsed = await Http.get(`order`, {
      searchParams: para,
    }).json();
    if (parsed.state === "ok") {
      setEdition(parsed.result);
    }
  };

  const onLoading = async () => {
    setLoading(true);
    try {
      await onNewsCount({ brandId: brand.id });
      await onProductCount({ brandId: brand.id });
      // await onChartLineLoad({ brandId: brand.id });
      // await onChartPizzLoad({ brandId: brand.id });
      await onGuide({ brandId: brand.id });
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (brand) {
      onLoading();
      onEdition();
    }
  }, [brand]);

  // useEffect(() => {
  //   if (stars.order === "ASC" && stars.current < stars.max) {
  //     let h = setInterval(() => {
  //       setStars({ ...stars, current: stars.current + 1 });
  //     }, 200);
  //     return () => {
  //       clearInterval(h);
  //     };
  //   }
  //   if (stars.order === "DESC" && stars.current > stars.min) {
  //     let h = setInterval(() => {
  //       setStars({ ...stars, current: stars.current - 1 });
  //     }, 100);
  //     return () => {
  //       clearInterval(h);
  //     };
  //   }
  // }, [stars]);

  return (
    <div className={styles.Overview}>
      <div className={styles.overviewLeft}>
        <div className={styles.information}>
          <div className={styles.user}>
            <div className={styles.avatar}>
              <Avatar
                size={64}
                style={{ backgroundColor: "#fde3cf" }}
                src={
                  user?.avatar
                    ? user.avatar
                    : "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                }
              />
            </div>
            <div className={styles.text}>
              <h2>
                您好！{user?.username ? user.username : "-----"} ,
                愿您的生意天天上升，情绪时时开心！
              </h2>
              <p>
                当前等级：{edition.edition ? edition.edition.name : ""}
                <a
                  href="https://sso.chinaqyz.com/shop?active=6"
                  target="_blank"
                >
                  立即升级&gt;&gt;
                </a>
              </p>
            </div>
          </div>
          <div className={styles.data}>
            <Space size={48}>
              <Statistic
                title="在线产品"
                value={productCount.ok}
                prefix={<AppstoreOutlined style={{ fontSize: 21 }} />}
              />
              <Statistic
                title="拒审产品"
                value={productCount.fail}
                prefix={<AppstoreOutlined style={{ fontSize: 21 }} />}
              />
              <Statistic
                title="待发产品"
                value={productCount.wait}
                prefix={<AppstoreOutlined style={{ fontSize: 21 }} />}
              />
              <Statistic
                title="在线文章"
                value={newsCount.ok}
                prefix={<CopyOutlined style={{ fontSize: 21 }} />}
              />
              <Statistic
                title="拒审文章"
                value={newsCount.fail}
                prefix={<CopyOutlined style={{ fontSize: 21 }} />}
              />
              <Statistic
                title="待发文章"
                value={newsCount.wait}
                prefix={<CopyOutlined style={{ fontSize: 21 }} />}
              />
            </Space>
          </div>
        </div>
        <div className={styles.shortcut}>
          <div
            className={styles.col}
            onClick={() => navigate("/website/brand")}
          >
            <div className={styles.icon}>
              <ShopFilled />
            </div>
            <i>店铺装修</i>
          </div>
          <div
            className={styles.col}
            onClick={() => navigate("/website/product/save")}
          >
            <div className={styles.icon}>
              <PlusCircleFilled />
            </div>
            <i>发布产品</i>
          </div>
          <div
            className={styles.col}
            onClick={() => navigate("/website/product")}
          >
            <div className={styles.icon}>
              <AppstoreFilled />
            </div>
            <i>产品管理</i>
          </div>
          <div
            className={styles.col}
            onClick={() => navigate("/website/news/save")}
          >
            <div className={styles.icon}>
              <FileAddFilled />
            </div>
            <i>发布文章</i>
          </div>
          <div className={styles.col} onClick={() => navigate("/website/news")}>
            <div className={styles.icon}>
              <CopyFilled />
            </div>
            <i>文章管理</i>
          </div>
          <div
            className={styles.col}
            onClick={() => navigate("/website/gbook")}
          >
            <div className={styles.icon}>
              <MessageFilled />
            </div>
            <i>留言管理</i>
          </div>
          <div
            className={styles.col}
            onClick={() => navigate("/website/report")}
          >
            <div className={styles.icon}>
              <FileExcelFilled />
            </div>
            <i>报表下载</i>
          </div>
        </div>
        <div className={styles.assistant}>
          <div className={styles.title}>
            <RobotFilled />
            <i>开店助手</i>
          </div>
          <div className={styles.box}>
            <div className={styles.row}>
              <div className={styles.ico}>
                <InsuranceFilled
                  style={{ fontSize: "68px", color: "#ffffff" }}
                />
              </div>
              <div className={styles.txt}>
                <p>第一步：完成企业/个人认证</p>
                <p>完成企业认证后，更容易达成交易</p>
                <p>已完成</p>
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.ico}>
                <ShopFilled style={{ fontSize: "68px", color: "#ffffff" }} />
              </div>
              <div className={styles.txt}>
                <p>第二步：完善店铺信息</p>
                <p>完成店铺信息，更容易达成交易</p>
                {guide.webBanner ? (
                  <p>已完成</p>
                ) : (
                  <Link to="/website/brand">立即完善</Link>
                )}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.ico}>
                <CustomerServiceFilled
                  style={{ fontSize: "68px", color: "#ffffff" }}
                />
              </div>
              <div className={styles.txt}>
                <p>第三步：添加客服代码</p>
                <p>添加客服代码后，买家能直接联系到您</p>
                {guide.script ? (
                  <p>已完成</p>
                ) : (
                  <Link to="/website/brand?active=4">立即完善</Link>
                )}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.ico}>
                <CopyFilled style={{ fontSize: "68px", color: "#ffffff" }} />
              </div>
              <div className={styles.txt}>
                <p>第四步：发布文章/产品</p>
                <p>发布文章/产品，展现给买家</p>
                {guide.newsHas && guide.productHas ? (
                  <p>已完成</p>
                ) : (
                  <Link to="/website/news">立即完善</Link>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className={styles.score}>
          <div className={styles.title}>
            <SafetyCertificateFilled />
            <i>品牌星级</i>
          </div>
          <div className={styles.show}>
            <div className={styles.showLeft}>
              <Rate
                allowHalf={true}
                count={7}
                value={stars.current}
                style={{ fontSize: 36, marginBottom: 20 }}
              />
              <Button
                type="primary"
                loading={stars.loading}
                onClick={onDiagnosis}
                icon={<ThunderboltFilled />}
              >
                重新检测
              </Button>
            </div>
            <div className={styles.showRight}>
              <h2>
                您的品牌评价为<span>{stars.current}</span>
                颗星，请根据下方提示进行完善，一个完整，信息丰富的品牌更方便与顾客撮合交易！
              </h2>
            </div>
          </div>
          <div className={styles.text}>
            系统检测您的品牌共有<span>{diagnosis.length}</span>
            个问题可优化，建议您马上处理！
          </div>
          <div className={styles.problem}>
            {diagnosis.map((value) => (
              <Link to={value.url} key={value.msg}>
                <h2>{value.msg}</h2>
              </Link>
            ))}
          </div>
        </div> */}
        {/* <div className={styles.flow}>
          <div className={styles.col}>
            <span>999</span>
            <span>今日流量</span>
          </div>
          <div className={styles.col}>
            <span>999</span>
            <span>昨日流量</span>
          </div>
          <div className={styles.col}>
            <span>999</span>
            <span>本周流量</span>
          </div>
          <div className={styles.col}>
            <span>999</span>
            <span>本月流量</span>
          </div>
        </div> */}
        {/* <div className={styles.chart}>
          <div className={styles.line}>
            <div className={styles.title}>
              <h2>
                <FundFilled />
                <i>昨日流量趋势</i>
              </h2>
              <p>（ 2020-08-25 ~ 2020-08-26 ）</p>
            </div>
            <div className={styles.box} ref={chartLine}></div>
          </div>
          <div className={styles.pizz}>
            <div className={styles.title}>
              <h2>
                <PieChartFilled />
                <i>搜索引擎关键词比例</i>
              </h2>
              <p>（ 2020-08 ~ 2020-09 ）</p>
            </div>
            <div className={styles.box} ref={chartPizz}></div>
          </div>
        </div> */}
      </div>
      <div className={styles.overviewRight}>
        <div className={styles.item}>
          <a href="https://sso.chinaqyz.com/shop?active=1" target="_blank">
            <img src={item1} alt="" />
          </a>
          <a href="https://sso.chinaqyz.com/shop?active=2" target="_blank">
            <img src={item2} alt="" />
          </a>
          <a href="https://sso.chinaqyz.com/shop?active=6" target="_blank">
            <img src={item3} alt="" />
          </a>
          <a href="https://sso.chinaqyz.com/shop?active=5" target="_blank">
            <img src={item4} alt="" />
          </a>
          <a href="https://sso.chinaqyz.com/shop?active=7" target="_blank">
            <img src={item5} alt="" />
          </a>
          <a href="https://sso.chinaqyz.com/shop?active=8" target="_blank">
            <img src={item6} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Overview;
